import type { ApiResponse, Pagination } from "@/types";

import { BaseApi } from "../base.api";

/**
 * Kursga yozilgan savol yoki izoh — javoblari bir qavat chuqurlikda.
 *
 * Buni faqat yozilgan o'quvchilar va kursning o'qituvchisi o'qiy va yoza oladi:
 * backend har bir yo'lni `CourseAccessService` orqali qo'riqlaydi, shuning
 * uchun so'rov o'tgan zahoti UI ipni ko'rsataversa bo'ladi.
 */
export interface CourseComment {
  id: number;
  text: string;
  userId: number;
  courseId: number;
  parentId: number | null;
  createdAt: string;
  updatedAt: string;
  user?: { id: number; firstName: string; lastName: string; avatarUrl: string | null };
  /** Faqat ildiz izohlarda keladi; backend ularni bitta so'rovda oladi. */
  replies?: CourseComment[];
}

export interface CreateCommentData {
  text: string;
  /** Shu izohga javob. Faqat bitta qavat — javobga javob rad etiladi. */
  parentId?: number;
}

export interface CommentFilter {
  page?: number;
  limit?: number;
}

/** Kurs izohlari API — backend'dagi `CommentsController` ning ko'zgusi. */
export class CommentsApi extends BaseApi {
  list(courseId: number, filter: CommentFilter) {
    return this.request.get<CourseComment[], Pagination<CourseComment>>(
      `/courses/${courseId}/comments`,
      { params: filter },
    );
  }

  create(courseId: number, data: CreateCommentData) {
    return this.request.post<CourseComment, ApiResponse<CourseComment>>(
      `/courses/${courseId}/comments`,
      data,
    );
  }

  update(id: number, text: string) {
    return this.request.patch<CourseComment, ApiResponse<CourseComment>>(`/comments/${id}`, {
      text,
    });
  }

  remove(id: number) {
    return this.request.delete<null, ApiResponse<null>>(`/comments/${id}`);
  }
}

export const commentsApi = new CommentsApi();
